import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import theme from '../../../../themes/green';

const style = {
  list: Object.assign(...theme.font, {
    padding: '0',
    listStyleType: 'none',
    label: {
      ...theme.font,
      fontSize: '11px',
      fontWeight: '400',
      flex: '0 0 20%',
    },
    value: {
      fontSize: '11px',
      fontWeight: 'bold',
      flex: '0 0 80%',
    },
  }),
};
const ProjectDetailsRow = (props) => {
  if (props.value) {
    let values = [];
    if (props.value === Object(props.value)) {
      values = Object.entries(props.value).map(([key, entry]) => (
        <div key={key} style={style.list.value}>
          {entry.displayName}
        </div>
      ));
    } else {
      values = <div style={style.list.value}>{props.value}</div>;
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: '5px',
        }}
      >
        <div style={style.list.label}> {props.label} </div>
        {values}
      </div>
    );
  }
  return null;
};

ProjectDetailsRow.defaultProps = {
  value: null,
};

ProjectDetailsRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

export default Radium(ProjectDetailsRow);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ProjectDetailsList/ProjectDetailsRow.js